import { Injectable, inject } from '@angular/core';
import { authState, signInWithEmailAndPassword, createUserWithEmailAndPassword,
    sendEmailVerification, sendPasswordResetEmail, signOut, signInWithPopup,
    GoogleAuthProvider, Auth } from '@angular/fire/auth';
import { doc, setDoc, Firestore } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { type Observable, BehaviorSubject } from 'rxjs';

export interface User {
    uid: string;
    email: string;
    displayName: string;
    photoURL: string;
    emailVerified: boolean;
 }

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  afs = inject(Firestore);
  afAuth = inject(Auth);
  router = inject(Router);

  userData: User | null; // Save logged in user data
  private currentUserSubject: BehaviorSubject<User>;
  currentUser: Observable<User>;
  loading = false;
  constructor() {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    /* Saving user data in localstorage when
    logged in and setting up null when logged out */
    authState(this.afAuth).subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    })
  }

  // Sign in with email/password
  SignIn(email, password) {
    this.loading = true;
    return signInWithEmailAndPassword(this.afAuth, email, password)
      .then((result) => {
        this.router.navigate(['home'],{skipLocationChange: true});
        this.SetUserData(result.user);
        this.currentUserSubject.next(result.user);
        this.loading = false;
      }).catch((error) => {
        window.alert(error.message);
        this.loading = false;
      })
  }
  userName: string;
  // Sign up with email/password
  SignUp(name, email, password) {
    if(!name) {
      this.userName = name;
      window.alert("Name is required");
      return;
    }
    this.loading = true;
    return createUserWithEmailAndPassword(this.afAuth, email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign
        up and returns promise */
        this.SendVerificationMail();
        this.SetUserData(result.user);
        this.loading = false;
      }).catch((error) => {
        window.alert(error.message)
        this.loading = false;
      })
  }

  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    return sendEmailVerification(this.afAuth.currentUser)
    .then(() => {
      this.router.navigate(['verify-email-address'], {skipLocationChange: true});
    })
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return sendPasswordResetEmail(this.afAuth, passwordResetEmail)
    .then(() => {
      window.alert('Password reset email sent, check your inbox.');
    }).catch((error) => {
      window.alert(error)
    })
  }
  admin: string[] = ['bddinecanberra@gmail.com'];
  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null
      && user.emailVerified !== false
      && !this.admin.includes(user.email)) ? true : false;
  }

   // Returns true when user is looged in and email is verified
   get isAdminLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null &&
      user.emailVerified !== false
      && this.admin.includes(user.email)) ? true : false;
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return signInWithPopup(this.afAuth, provider)
    .then((result) => {
      this.SetUserData(result.user);
    }).catch((error) => {
      window.alert(error)
    })
  }

  /* Setting up user data when sign in with username/password,
  sign up with username/password and sign in with social auth
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(user) {
    const userRef = doc(this.afs, `users/${user.uid}`);
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified
    }
    return setDoc(userRef, userData, { merge: true });
  }

  // Sign out
  SignOut() {
    return signOut(this.afAuth).then(() => {
      localStorage.removeItem('user');
      this.currentUserSubject.next(null);
      this.router.navigate(['login'], {skipLocationChange: true});
    })
  }

}
